import {useEffect, useMemo } from 'react';
import { Outlet} from 'react-router-dom';
import Particles, { initParticlesEngine } from '@tsparticles/react';
import { loadSlim } from '@tsparticles/slim';
import HomeNavBar from '../../components/organisms/HomeNavBar';

const AuthenticationLayout = ({children}) => {
  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    });
  }, []);

  const particlesLoaded = () => {};

  const options = useMemo(
    () => ({
      background: {
        color: {
          value: '',
        },
      },
      fpsLimit: 120,
      interactivity: {
        events: {
          onClick: {
            enable: true,
            mode: 'push',
          },
          onHover: {
            enable: true,
            mode: 'repulse',
          },
        },
        modes: {
          push: {
            quantity: 4,
          },
          repulse: {
            distance: 200,
            duration: 0.4,
          },
        },
      },
      particles: {
        color: {
          value: '#ffffff',
        },
        links: {
          color: '#ffffff',
          distance: 150,
          enable: true,
          opacity: 0.5,
          width: 1,
        },
        move: {
          direction: 'none',
          enable: true,
          outModes: {
            default: 'bounce',
          },
          random: false,
          speed: 6,
          straight: false,
        },
        number: {
          density: {
            enable: true,
          },
          value: 80,
        },
        opacity: {
          value: 0.5,
        },
        shape: {
          type: 'circle',
        },
        size: {
          value: { min: 1, max: 5 },
        },
      },
      detectRetina: true,
    }),
    []
  );
    const content = children ?? <Outlet />;

    return ( 
        <div className="relative min-h-screen bg-primary">
          {/* <HomeNavBar/> */}
          {/* Particles Background */}
      <div className="absolute inset-0 z-0">
        <Particles id="tsparticles" particlesLoaded={particlesLoaded} options={options} />
      </div>
            {/* <div className="relative bg-primary  flex justify-center items-center ">
            <div className=" bg-white rounded-[24px] border-t-8 border-yellow-500 p-8 lg:p-0 ">
                <div className="h-full flex justify-center items-center">
                {props.signinForm}
                </div>
                
            </div>
            </div> */}
            {/*  */}
            
            <div className="relative z-10 px-4 pt-4">
          <HomeNavBar hideLinks />
        </div>

        <div className="">
  <div
    className="min-h-[calc(100vh-4rem)] backdrop-blur-sm bg-primary/10 flex justify-center items-center px-4 py-6"
    style={{
      backgroundImage: `url(${require('../../assets/images.png')})`,
      backgroundSize: 'contain', // ensures the image covers the entire container
      backgroundPosition: 'center', // ensures the image is centered
      backgroundRepeat: 'repeat', // prevents the image from repeating
    }}
  >
    
    
  
    {/* <AuthenticationCard /> */}
    {content}
 
  </div>
</div>

        </div>
     );
}
 
export default AuthenticationLayout;
